import { services } from '../../../api';
import { Result } from '../../../shared/utils/enums';

/**
 * Enrolls a user in a course by making an API request.
 *
 * @async
 * @function enrollInCourse
 * @param {number} courseId - The ID of the course to enroll in.
 * @returns {Promise<boolean>} A promise that resolves to `true` if enrollment is successful, or `false` if it fails.
 */
export const enrollInCourse = async (courseId: number): Promise<boolean> => {
  try {
    const res = await services.courses.enrollInCourse(courseId);
    return res.result === Result.Success;
  } catch (error) {
    console.error('Enrollment failed:', error);
    return false;
  }
};
